<template>
    <MainContentTabs
        :tabs="[
            {tab : 'opciones', nombre: 'Activar / Desactivar opciones'},
            {tab : 'imagenes-web', nombre: 'Cambiar imágenes web'},
            {tab : 'imagenes-entrada', nombre: 'Cambiar imágenes entrada'},
            {tab : 'imagenes-productos', nombre: 'Cambiar imágenes de productos'},
            {tab : 'imagenes-base', nombre: 'Cambiar imágenes de deportista'},
            {tab : 'abonos', nombre: 'Abonos'},
            {tab : 'patrocinadores', nombre: 'Patrocinadores'},
            {tab : 'tipo-entrada', nombre: 'Tipo de entrada'},
            {tab : 'deportistas', nombre: 'Deportistas'},
            {tab : 'Metodos-pago', nombre: 'Métodos de pago'},
            ...(isManager ? [{tab : 'api-crm', nombre: 'Api crm'}] : [])
        ]"
        initialTab="opciones"
        title="Configuración"
    >
        <template slot="opciones">
            <Opciones :manager="manager" :loading="loading" @guardar="guardarOpciones"/>
        </template>
        <template slot="imagenes-web">
            <ImagenesWeb :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="imagenes-entrada">
            <ImagenesEntrada :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="imagenes-productos">
            <ImagenesProductos :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="imagenes-base">
            <ImagenesBase :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="abonos">
            <Abonos :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="patrocinadores">
            <Patrocinadores/>
        </template>
        <template slot="tipo-entrada">
            <TipoEntrada :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="deportistas">
            <Bases :manager="manager" @guardar="guardarOpciones"/>
        </template>
        <template slot="Metodos-pago">
            <MetodosPago/>
        </template>
        <template slot="api-crm" v-if="isManager">
            <ApiCrm/>
        </template>
    </MainContentTabs>
</template>

<script>
    import MainContentTabs from '@/components/backend/components/MainContentTabs';
    import Opciones from './Opciones';
    import ImagenesWeb from './ImagenesWeb';
    import ImagenesEntrada from './ImagenesEntrada';
    import Patrocinadores from './Patrocinadores';
    import TipoEntrada from './TipoEntrada.vue'
    import Bases from './Bases.vue';
    import ApiCrm from './ApiCrm.vue';
    import Abonos from './Abonos.vue';
    import ImagenesBase from './ImagenesBase.vue';
    import MetodosPago from './MetodosPago.vue';
    import ImagenesProductos from './ImagenesProductos';

    export default {
        data() {
            return {
                loading: false
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            isManager() {
                return this.$store.getters.getUser.id === this.$store.getters.getFooter.user_id;
            }
        },
        methods: {
            guardarOpciones(manager) {
                this.loading = true;
    
                const params = {
                    filters : {},
                    lista_id: this.$store.getters.getListaId,
                    nuevo_abono: manager.nuevo_abono,
                    renovar_abono: manager.renovar_abono,
                    partidos: manager.partidos,
                    venta_simpatizantes: manager.venta_simpatizantes,
                    futbol_base: manager.futbol_base,
                    bg1: manager.bg1,
                    bg2: manager.bg2,
                    bg3: manager.bg3,
                    bg4: manager.bg4,
                    bg5: manager.bg5,
                    imagen_patrocinadores: manager.imagen_patrocinadores,
                    imagen_cabecera: manager.imagen_cabecera,
                    imagen_cabecera_productos: manager.imagen_cabecera_productos,
                    imagen_publicidad: manager.imagen_publicidad,
                    imagen_publicidad_productos: manager.imagen_publicidad_productos,
                    imagen_info_bases: manager.imagen_info_bases,
                    informacion_base: manager.informacion_base,
                    activar_compra_por_invitacion_bases: manager.activar_compra_por_invitacion_bases,
                    tipo_entrada: manager.tipo_entrada,
                    termino_entrada: manager.termino_entrada,
                    termino_entradas: manager.termino_entradas,
                    ocultar_iva_entradas: manager.ocultar_iva_entradas,
                    ocultar_abonos: manager.ocultar_abonos,
                    ocultar_simpatizantes: manager.ocultar_simpatizantes,
                    activar_experiencias: manager.activar_experiencias,
                    ocultar_experiencias: manager.ocultar_experiencias,
                    ocultar_futbol_base: manager.ocultar_futbol_base,
                    activar_pack: manager.activar_pack,
                    ocultar_pack: manager.ocultar_pack,
                    ocultar_eventos: manager.ocultar_eventos,
                    ocultar_renovar_abono: manager.ocultar_renovar_abono,
                    renovacion_futbol_base: manager.renovacion_futbol_base,
                    ocultar_renovacion_futbol_base: manager.ocultar_renovacion_futbol_base,
                    imagen_abono_cabecera: manager.imagen_abono_cabecera,
                    imagen_abono_publicidad: manager.imagen_abono_publicidad,
                    imagen_abono_patrocinadores: manager.imagen_abono_patrocinadores,
                    condiciones_bases_plazos: manager.condiciones_bases_plazos,
                    imagen_base_patrocinadores: manager.imagen_base_patrocinadores,
                    imagen_base_cabecera: manager.imagen_base_cabecera,
                    imagen_base_publicidad: manager.imagen_base_publicidad,
                    condiciones_abonos_plazos: manager.condiciones_abonos_plazos,
                    documentacion_obligatoria_bases: manager.documentacion_obligatoria_bases,
                    renovar_abono_solo_con_dni: manager.renovar_abono_solo_con_dni,
                    comprobar_dni: manager.comprobar_dni,
                    comprobacion_butacas_abonos: manager.comprobacion_butacas_abonos,
                    activar_acreditaciones: manager.activar_acreditaciones,
                    ocultar_acreditaciones: manager.ocultar_acreditaciones,
                    activar_productos: manager.activar_productos,
                    ocultar_productos: manager.ocultar_productos,
                    activar_parcelas: manager.activar_parcelas,
                    ocultar_parcelas: manager.ocultar_parcelas,
                    ocultar_afiliados: manager.ocultar_afiliados
                };
    
                this.$store.dispatch(this.config.getVuexAlias('back.lista.editar.manager'), params).then(res => {
                    this.$toast.success(res.data.message);
                });
    
                setTimeout(() => {
                    this.loading = false;
                    this.$store.dispatch(this.config.getVuexAlias('settings'));
                }, 2000);
            }
        },
        components: {
            Opciones, ImagenesWeb, ImagenesEntrada, Patrocinadores, MainContentTabs, TipoEntrada, Bases, ApiCrm, Abonos, ImagenesBase, MetodosPago, ImagenesProductos
        }
    }
</script>